<div class="tt-c-review-toolbar">
  <div class="tt-c-review-toolbar__content--left tt-u-spacing--left--md">
    <span class="tt-c-review-toolbar__text" v-html="$msg('review.wasHelpful')"></span>
    <tt-button type="toolbar" class="tt-c-review-toolbar__vote" @click.prevent="upVote" :aria-label="$msg('review.voteUp', [username, upVoteCount], upVoteCount)" :aria-pressed="wasUpVoted.toString()"><tt-icon :name="upVoteIconName" size="sm" class="tt-c-review-toolbar__icon"></tt-icon><span class="tt-c-review-toolbar__likes-number">{{ upVoteCount }}</span></tt-button>
    <tt-button type="toolbar" class="tt-c-review-toolbar__vote" @click.prevent="downVote" :aria-label="$msg('review.voteDown', [username, downVoteCount], downVoteCount)" :aria-pressed="wasDownVoted.toString()"><tt-icon :name="downVoteIconName" :aria-hidden="true" size="sm" class="tt-c-review-toolbar__icon"></tt-icon><span class="tt-c-review-toolbar__dislikes-number">{{ downVoteCount }}</span></tt-button>
  </div>
  <div class="tt-c-review-toolbar__content--right">
    <div class="tt-c-review-toolbar__actions tt-u-spacing--left--lg">
      <tt-button class="tt-c-review-toolbar__action tt-c-review-toolbar__action--flag"
                 type="toolbar"
                 @click="flag"
                 :disabledClassOnly="wasFlagged"
                 :aria-disabled="wasFlagged"
                 :aria-label="flagAriaLabel">
        <tt-icon :name="flagIconName"></tt-icon><span v-html="flagText"></span>
      </tt-button>
      <div v-show="wasFlagged" role="status" class="tt-u-clip-hide">{{$msg('review.flagged.aria', [username])}}</div>
      <a v-if="isModerator"
         :href="moderationUrl"
         target="_blank"
         class="tt-c-review-toolbar__action tt-c-review-toolbar__action--moderate"
         rel="nofollow">
         <tt-icon name="moderate"></tt-icon>
         <span v-html="$msg('mediaModal.moderate')"></span>
      </a>
      <tt-menu class="tt-c-review-toolbar__menu" :tiggerAriaLabel="$msg('review.optionsMenu')" triggerClass="tt-c-review-toolbar__menu-trigger" triggerType="icon">
        <template v-slot:triggerContent><tt-icon name="more-h" size="sm"></tt-icon></template>
        <tt-menu-list alignMenu="right" :menuItems="menuItems" @menuItemSelected="menuItemSelected"></tt-menu-list>
      </tt-menu>
    </div>
  </div>
</div>
